import { getStateData, loadState } from '@/store'
import { identifyUserInAnalytics } from '@/services/analytics'
import { translationProvider } from '@/services/translationProvider'
import { identifyUserInTracking } from '@/services/tracking'
import { auth } from '@/modules/auth'

// Re-entrancy guard: loadState() calls significant state mutations that can
// trigger watchers, which in turn can call loadUserData again.
// This guard prevents multiple simultaneous executions of loadState.
let _loading = false

export const loadUserData = async (onLogin = false) => {
  if (_loading) return

  _loading = true

  try {
    const token = await auth.value?.getAuthToken()

    if (!token) {
      console.warn('[otters-shell - userDataHelper] - Undefined token')
      return
    }

    if (!(await loadState())) {
      return
    }

    identifyUserInAnalytics({ onLogin })

    await translationProvider.set(getStateData().language)
    identifyUserInTracking()
  } finally {
    _loading = false
  }
}
